// extracted by mini-css-extract-plugin
module.exports = {"MealsSummary":"MealsSummary_MealsSummary__311Y-"};